/**
 * Le thème de DÉPART de l'app — celui que peint toute surface du design system montée hors d'un
 * espace : le rapport de LIVE ouvert par son lien (`/r`), le tableau de parrainage hors de
 * l'espace parent, un composant du DS dans un écran qui date.
 *
 * C'est, valeur pour valeur, ce que le thème élève valait tant qu'il ne repointait que `role` : le
 * socle, et le corail là où une sélection se lit. Il est figé ici pour que le thème élève puisse
 * devenir celui du livre sans déplacer un pixel de ces surfaces, qui sont en production. Il
 * disparaît le jour où chaque espace pose son thème à son entrée, comme le fait l'espace parent
 * (`useParentThemeScope`), et où ces surfaces posent le leur.
 */
import { baseTheme } from "./base"
import { brand } from "./tokens/colors"

export const initialTheme = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        role: brand.roleStudent,
        "role-strong": brand.roleStudent,
        "role-selected": brand.roleStudent,
    },
} as const
